import { Paragraph } from 'component/base/Text';
import { ManualStepOneForm } from 'component/form/Onboarding';
import { push } from 'connected-react-router';
import { FlexAlignment, Intent } from 'enums';
import { useAppDispatch } from 'hooks/reduxHooks';
import { useContext as useUserOnboardingFormContext } from 'providers/UserOnboardingForm';
import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import ScrollToTop from 'react-router-scroll-top';

import { Menu, PrimaryLink } from '../../base/Header';
import { Logo } from '../../base/Logo';
import { Container, Content, FixedWidth, Header, Title } from './styles';

const OnboardingManualEmailView = () => {
  const dispatch = useAppDispatch();
  const { updateState } = useUserOnboardingFormContext();
  useEffect(() => {
    // Clear the token value (in case the user navigated back)
    // dispatch(change('onboarding', 'token', ''));
    updateState({ token: '' });
  }, [updateState]);

  const handleNext = (values: { email: string }) => {
    updateState(values);
    dispatch(push('/onboarding/register/activate'));
  };

  return (
    <>
      <Helmet title="Invite" />
      <ScrollToTop />
      <Container>
        <Header>
          <Content>
            <Logo />
            <Menu>
              Already have an account?
              <PrimaryLink to="/login">Sign in</PrimaryLink>
            </Menu>
          </Content>
        </Header>
        <Title>Confirm your email</Title>
        <Paragraph textAlign={FlexAlignment.CENTER} intent={Intent.SECONDARY}>
          Please enter the email address your BeeCastle invite was sent to.
        </Paragraph>
        <Paragraph textAlign={FlexAlignment.CENTER} intent={Intent.SECONDARY}>
          To use BeeCastle you must be invited by your admin account.
        </Paragraph>
        <FixedWidth width={650} mt={2}>
          <ManualStepOneForm next={handleNext} />
        </FixedWidth>
      </Container>
    </>
  );
};

export default OnboardingManualEmailView;
